if(window.location.pathname === '/pages/silviafindings-usa-diy-jewelry-wholesale-registrastion-form'){
  setTimeout(()=> {

    const address_field = document.querySelector(".field-address-field");
    const address_2_field = document.querySelector(".field-text-1716813306516-0");
    const city_field = document.querySelector(".field-city-field");
    const zip_field = document.querySelector(".field-zip-field");
    const country_field = document.querySelector(".field-country-field");
    const state_field = document.querySelector(".field-state-field");
    const custom_form = document.querySelector("#bss-b2b-registration-form-render .rendered-form .field-file-1716812831886-0");
    const password_field = document.querySelector(".password-field");
    const userName_field = document.querySelector(".field-text-1716813483789-0");

    const company = document.querySelector(".field-text-1716812248298-0");
    const business = document.querySelector(".field-text-1716812730030");
    const website = document.querySelector(".field-text-1716812323264-0");

    const email = document.querySelector(".RegisterForm-email");

    //label
    const cb_label = document.querySelector('[for="checkbox-group-1716813755159-0-0"]');
    //submit
    const submit_btn = document.querySelector('input[type="submit"]');
    if(submit_btn){
      submit_btn.value = "I'd like a wholesale account with SilviaFindings, USA";
    }
    if(cb_label){
      cb_label.innerHTML = 'I have read and accept SilviaFindings, <a href = "https://diyjewelry.us/terms-of-service">USA Terms Of Service</a>';
    }
    if(address_field && address_2_field && city_field && zip_field && country_field  && state_field){
      const div = document.createElement("div");
      const div2 = document.createElement("div");
      div.className = 'bss-grid';
      div2.className = 'bss-grid grid-group';
      div.append(address_field);
      div.append(address_2_field);
      div2.append(city_field);
      div2.append(zip_field);
      div2.append(country_field);
      div2.append(state_field);
      div.append(div2);
      custom_form.after(div)
    }
    if(userName_field && password_field){
      userName_field.after(password_field);
    }
    if(email && company && business && website){
      email.after(company);
      company.classList.add("field");
      business.classList.add("field");
      website.classList.add("field");
      company.after(business);
      business.after(website);
    }
  }, 200)

 
}


  
  setTimeout(() => {
  const header = document.querySelector('#MainContent > div > div > div.grid__item.medium-up--five-sixths.medium-up--push-one-twelfth');
  if (header) {
    const html = `
      <div class="form_title_div" tabindex="0" aria-label="Wholesale Registrastion Form

Use this form to register for our membership program.

New registrations require approval from DIY Jewelry



	
		
			
			
			DIY JEWELRY

			SILVIAFINDINGS, USA

			650 South Orcas Street, Suite 207
			Seattle, WA 98108
			Office:  206-762-5018&nbsp; 

			Cell:&nbsp;360-821-6696
			Emails: info@silviafindings.us or&nbsp; info@diyjewerly.us
			Website: www.diyjewelry.us
			
		
	



&nbsp;
" aria-describedby="Form title" bis_size="{&quot;x&quot;:37,&quot;y&quot;:57,&quot;w&quot;:1055,&quot;h&quot;:492,&quot;abs_x&quot;:52,&quot;abs_y&quot;:257}"><h1 style="text-align: center;" bis_size="{&quot;x&quot;:37,&quot;y&quot;:57,&quot;w&quot;:1055,&quot;h&quot;:39,&quot;abs_x&quot;:52,&quot;abs_y&quot;:257}">Wholesale Registrastion Form</h1>

<p center="" style="text-align: center;" bis_size="{&quot;x&quot;:37,&quot;y&quot;:106,&quot;w&quot;:1055,&quot;h&quot;:26,&quot;abs_x&quot;:52,&quot;abs_y&quot;:306}">Use this form to register for our membership program.</p>

<address center="" style="text-align: center;" bis_size="{&quot;x&quot;:37,&quot;y&quot;:142,&quot;w&quot;:1055,&quot;h&quot;:21,&quot;abs_x&quot;:52,&quot;abs_y&quot;:342}"><em bis_size="{&quot;x&quot;:326,&quot;y&quot;:144,&quot;w&quot;:475,&quot;h&quot;:17,&quot;abs_x&quot;:341,&quot;abs_y&quot;:344}"><strong bis_size="{&quot;x&quot;:326,&quot;y&quot;:144,&quot;w&quot;:475,&quot;h&quot;:17,&quot;abs_x&quot;:341,&quot;abs_y&quot;:344}"><span style="color:#41658a;" bis_size="{&quot;x&quot;:326,&quot;y&quot;:144,&quot;w&quot;:475,&quot;h&quot;:17,&quot;abs_x&quot;:341,&quot;abs_y&quot;:344}"><span data-mce-style="color: red;" bis_size="{&quot;x&quot;:326,&quot;y&quot;:144,&quot;w&quot;:475,&quot;h&quot;:17,&quot;abs_x&quot;:341,&quot;abs_y&quot;:344}">New registrations require approval from DIY Jewelry</span></span></strong></em></address>

<hr bis_size="{&quot;x&quot;:37,&quot;y&quot;:184,&quot;w&quot;:1055,&quot;h&quot;:1,&quot;abs_x&quot;:52,&quot;abs_y&quot;:384}">
<table align="center" cellpadding="5" cellspacing="5" class="table_top" bis_size="{&quot;x&quot;:236,&quot;y&quot;:195,&quot;w&quot;:655,&quot;h&quot;:307,&quot;abs_x&quot;:251,&quot;abs_y&quot;:395}">
	<tbody bis_size="{&quot;x&quot;:236,&quot;y&quot;:195,&quot;w&quot;:655,&quot;h&quot;:307,&quot;abs_x&quot;:251,&quot;abs_y&quot;:395}">
		<tr flex="style=display:" bis_size="{&quot;x&quot;:236,&quot;y&quot;:195,&quot;w&quot;:655,&quot;h&quot;:307,&quot;abs_x&quot;:251,&quot;abs_y&quot;:395}">
			<td center="style=text-align:" bis_size="{&quot;x&quot;:236,&quot;y&quot;:195,&quot;w&quot;:307,&quot;h&quot;:307,&quot;abs_x&quot;:251,&quot;abs_y&quot;:395}"><a href="https://cdn.shopify.com/s/files/1/0588/4860/8317/files/siliva-store-removebg-preview_430x.png?v=1703249637" bis_size="{&quot;x&quot;:236,&quot;y&quot;:338,&quot;w&quot;:307,&quot;h&quot;:17,&quot;abs_x&quot;:251,&quot;abs_y&quot;:538}"><img 307px="alt=SilviaFindings®" src="https://cdn.shopify.com/s/files/1/0588/4860/8317/files/siliva-store-removebg-preview_430x.png?v=1703249637;" style="width:" bis_size="{&quot;x&quot;:236,&quot;y&quot;:195,&quot;w&quot;:307,&quot;h&quot;:307,&quot;abs_x&quot;:251,&quot;abs_y&quot;:395}"></a></td>
			<td 350px="style=width:" bis_size="{&quot;x&quot;:543,&quot;y&quot;:195,&quot;w&quot;:348,&quot;h&quot;:307,&quot;abs_x&quot;:558,&quot;abs_y&quot;:395}">
			<h2 center="" style="text-align: center;" bis_size="{&quot;x&quot;:543,&quot;y&quot;:225,&quot;w&quot;:348,&quot;h&quot;:33,&quot;abs_x&quot;:558,&quot;abs_y&quot;:425}">DIY JEWELRY</h2>

			<h4 center="" style="text-align: center;" bis_size="{&quot;x&quot;:543,&quot;y&quot;:268,&quot;w&quot;:348,&quot;h&quot;:22,&quot;abs_x&quot;:558,&quot;abs_y&quot;:468}">SILVIAFINDINGS, USA</h4>

			<p center="" style="text-align: center;" bis_size="{&quot;x&quot;:543,&quot;y&quot;:300,&quot;w&quot;:348,&quot;h&quot;:84,&quot;abs_x&quot;:558,&quot;abs_y&quot;:500}">650 South Orcas Street, Suite 207<br bis_size="{&quot;x&quot;:884,&quot;y&quot;:302,&quot;w&quot;:0,&quot;h&quot;:22,&quot;abs_x&quot;:899,&quot;abs_y&quot;:502}">
			<span style="font-size:12px;" bis_size="{&quot;x&quot;:659,&quot;y&quot;:335,&quot;w&quot;:116,&quot;h&quot;:14,&quot;abs_x&quot;:674,&quot;abs_y&quot;:535}">Seattle, WA 98108</span><br bis_size="{&quot;x&quot;:776,&quot;y&quot;:328,&quot;w&quot;:0,&quot;h&quot;:22,&quot;abs_x&quot;:791,&quot;abs_y&quot;:528}">
			<span style="font-size:12px;" bis_size="{&quot;x&quot;:645,&quot;y&quot;:364,&quot;w&quot;:52,&quot;h&quot;:14,&quot;abs_x&quot;:660,&quot;abs_y&quot;:564}"><strong bis_size="{&quot;x&quot;:645,&quot;y&quot;:364,&quot;w&quot;:48,&quot;h&quot;:14,&quot;abs_x&quot;:660,&quot;abs_y&quot;:564}">Office:</strong> </span> <span style="font-size:12px;" bis_size="{&quot;x&quot;:698,&quot;y&quot;:364,&quot;w&quot;:91,&quot;h&quot;:14,&quot;abs_x&quot;:713,&quot;abs_y&quot;:564}">206-762-5018&nbsp; </span></p>

			<p center="" style="text-align: center;" bis_size="{&quot;x&quot;:543,&quot;y&quot;:394,&quot;w&quot;:348,&quot;h&quot;:87,&quot;abs_x&quot;:558,&quot;abs_y&quot;:594}"><span style="font-size:12px;" bis_size="{&quot;x&quot;:655,&quot;y&quot;:403,&quot;w&quot;:37,&quot;h&quot;:14,&quot;abs_x&quot;:670,&quot;abs_y&quot;:603}"><strong bis_size="{&quot;x&quot;:655,&quot;y&quot;:403,&quot;w&quot;:33,&quot;h&quot;:14,&quot;abs_x&quot;:670,&quot;abs_y&quot;:603}">Cell:</strong>&nbsp;</span><span style="font-size:12px;" bis_size="{&quot;x&quot;:692,&quot;y&quot;:403,&quot;w&quot;:88,&quot;h&quot;:14,&quot;abs_x&quot;:707,&quot;abs_y&quot;:603}">360-821-6696</span><br bis_size="{&quot;x&quot;:780,&quot;y&quot;:396,&quot;w&quot;:0,&quot;h&quot;:22,&quot;abs_x&quot;:795,&quot;abs_y&quot;:596}">
			<span style="font-size:12px;" bis_size="{&quot;x&quot;:543,&quot;y&quot;:432,&quot;w&quot;:348,&quot;h&quot;:14,&quot;abs_x&quot;:558,&quot;abs_y&quot;:632}"><strong bis_size="{&quot;x&quot;:543,&quot;y&quot;:432,&quot;w&quot;:58,&quot;h&quot;:14,&quot;abs_x&quot;:558,&quot;abs_y&quot;:632}">Emails: </strong><a href="mailto:info@silviafindings.us" bis_size="{&quot;x&quot;:602,&quot;y&quot;:432,&quot;w&quot;:141,&quot;h&quot;:14,&quot;abs_x&quot;:617,&quot;abs_y&quot;:632}">info@silviafindings.us</a> <strong bis_size="{&quot;x&quot;:747,&quot;y&quot;:432,&quot;w&quot;:15,&quot;h&quot;:14,&quot;abs_x&quot;:762,&quot;abs_y&quot;:632}">or</strong>&nbsp; <a href="mailto:info@diyjewerly.us" bis_size="{&quot;x&quot;:771,&quot;y&quot;:432,&quot;w&quot;:120,&quot;h&quot;:14,&quot;abs_x&quot;:786,&quot;abs_y&quot;:632}">info@diyjewerly.us</a></span><br bis_size="{&quot;x&quot;:892,&quot;y&quot;:425,&quot;w&quot;:0,&quot;h&quot;:22,&quot;abs_x&quot;:907,&quot;abs_y&quot;:625}">
			<span style="font-size:12px;" bis_size="{&quot;x&quot;:625,&quot;y&quot;:461,&quot;w&quot;:184,&quot;h&quot;:14,&quot;abs_x&quot;:640,&quot;abs_y&quot;:661}"><strong bis_size="{&quot;x&quot;:625,&quot;y&quot;:461,&quot;w&quot;:67,&quot;h&quot;:14,&quot;abs_x&quot;:640,&quot;abs_y&quot;:661}">Website: </strong><a href="https://www.diyjewelry.us" bis_size="{&quot;x&quot;:692,&quot;y&quot;:461,&quot;w&quot;:117,&quot;h&quot;:14,&quot;abs_x&quot;:707,&quot;abs_y&quot;:661}">www.diyjewelry.us</a></span></p>
			</td>
		</tr>
	</tbody>
</table>

<hr bis_size="{&quot;x&quot;:37,&quot;y&quot;:512,&quot;w&quot;:1055,&quot;h&quot;:1,&quot;abs_x&quot;:52,&quot;abs_y&quot;:712}">
<p bis_size="{&quot;x&quot;:37,&quot;y&quot;:523,&quot;w&quot;:1055,&quot;h&quot;:26,&quot;abs_x&quot;:52,&quot;abs_y&quot;:723}">&nbsp;</p>
</div>
<style>
.section-header.text-center {
  display: none!important;
}
</style>
    `;
    header.insertAdjacentHTML('afterbegin', html);
  }
}, 500);

